import { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { LOGIN_URL_LOCAL, REGISTER_URL_LOCAL } from "../../utility/BaseUrl";
import {
  PasswordRecovery2Service,
  PasswordRecoveryService,
} from "../../services/MainScreen";
import {
  ActiveCodeComponent,
  ConfirmPasswordComponent,
  TimerComponent,
  UserNameComponent,
} from "./loginComponent/LoginValidateComponent";

const ChangePassword = () => {
  const [state, setState] = useState({
    isLoading: false,
    level: 0,
    phone: "",
    password: { valid: false, value: "" },
    userData: {},
  });

  const navigate = useNavigate();

  const changeSlide = useCallback((next) => {
    setState((prevState) => ({
      ...prevState,
      level: next ? prevState.level + 1 : prevState.level - 1,
    }));
  }, []);

  const savePhone = async () => {
    const { phone } = state;
    if (phone.length !== 11) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "شماره موبایل باید 11 رقم باشد.",
        confirmButtonText: "باشه",
      });
      return;
    }
    try {
      setState((prev) => ({ ...prev, isLoading: true }));
      const response = await PasswordRecoveryService(phone);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "موفق!",
          text: response.message,
          confirmButtonText: "باشه",
        }).then(() => {
          setState((prev) => ({
            ...prev,
            userData: {
              phone,
              active_code: response.result.active_code.active_code,
            },
          }));
          changeSlide(true);
        });
      }
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const recoverPassword = async (event) => {
    event.preventDefault();
    const { password, userData } = state;
    if (!password.valid) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "رمز عبور و تکرار رمز عبور را وارد کنید!",
        confirmButtonText: "باشه",
      });
      return;
    }
    try {
      setState((prev) => ({ ...prev, isLoading: true }));
      const result = await PasswordRecovery2Service(
        userData.phone,
        userData.active_code,
        password.value,
        password.value
      );
      if (result.status === 200) {
        Swal.fire({
          icon: "success",
          title: "عملیات موفق",
          text: result.message,
          confirmButtonText: "باشه",
        }).then(() => navigate(LOGIN_URL_LOCAL));
      } else if (result.status === 400) {
        Swal.fire({
          icon: "error",
          title: result.message,
          html: `<ul><li>${result?.result?.active_code[0]}</li></ul>`,
          confirmButtonText: "باشه",
        });
      }
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const { isLoading, level, phone, password } = state;

  return (
    <>
      <main className="page-container signin-container" itemProp="mainEntity">
        <div className="container">
          <div className="row">
            <div className="col-3"></div>
            <div className="col-12 col-md-6">
              <h1
                className="page-title pb-20 mt-3 signin-title pt-20 pt-md-25  pt-lg-30  text-center w-100"
                itemProp="headline"
              >
                تغییر رمز عبور
              </h1>
              <div className="page-context signin-context text-center">
                {level === 0 ? (
                  <form
                    name="signin"
                    className="signin-form py-25 py-sm-30 py-md-35 pt-lg-10 pb-lg-10"
                    onSubmit={(e) => {
                      e.preventDefault();
                      savePhone();
                    }}
                  >
                    <UserNameComponent
                      phone={phone}
                      setPhone={(value) =>
                        setState((prev) => ({ ...prev, phone: value }))
                      }
                    />
                    <div className="row form-group signin-rememberme mt-20">
                      <div className="col-12 col-md-6 mt-2"></div>
                      <div className="ccol-12 col-md-6 mt-2">
                        <button
                          type="submit"
                          className="btn btn-lg btn-primary signin-submit shadow"
                          style={{ padding: "0.4625rem 1.1875rem" }}
                        >
                          تایید شماره
                        </button>
                        <div
                          className={
                            "page-loading signin-loading" +
                            (isLoading ? "" : " d-none")
                          }
                        >
                          <i className="fa fa-refresh fa-spin fa-fw" />
                          کمی‌صبر‌کنید...
                        </div>
                      </div>
                    </div>
                  </form>
                ) : level === 1 ? (
                  <div className="signin-form py-25 py-sm-30 py-md-35 pt-lg-10 pb-lg-10">
                    <ActiveCodeComponent
                      activeCode={state.userData.active_code}
                      goToNextSlide={() => changeSlide(true)}
                    />
                    <div className="row form-group signin-rememberme mt-20">
                      <div className="ccol-12 col-md-6 mt-2">
                        <button
                          type="button"
                          onClick={() => changeSlide(false)}
                          className="btn btn-lg btn-warning signin-submit shadow"
                          style={{ padding: "0.4625rem 1.1875rem" }}
                        >
                          تغییر شماره
                        </button>
                        <TimerComponent
                          onSendCode={function () {
                            savePhone();
                            changeSlide(false);
                          }}
                        />
                        <div
                          className={
                            "page-loading signin-loading" +
                            (isLoading ? "" : " d-none")
                          }
                        >
                          <i className="fa fa-refresh fa-spin fa-fw" />
                          کمی‌صبر‌کنید...
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <form
                    name="signin"
                    className="signin-form py-25 py-sm-30 py-md-35 pt-lg-10 pb-lg-10"
                    onSubmit={recoverPassword}
                  >
                    <ConfirmPasswordComponent
                      setPassword={(value) =>
                        setState((prev) => ({ ...prev, password: value }))
                      }
                    />
                    <div className="row form-group signin-rememberme mt-20">
                      <div className="col-12 col-md-6 mt-2"></div>
                      <div className="ccol-12 col-md-6 mt-2">
                        <button
                          type="submit"
                          className="btn btn-lg btn-primary signin-submit shadow"
                          style={{ padding: "0.4625rem 1.1875rem" }}
                        >
                          ثبت رمز جدید
                        </button>
                        <div
                          className={
                            "page-loading signin-loading" +
                            (isLoading ? "" : " d-none")
                          }
                        >
                          <i className="fa fa-refresh fa-spin fa-fw" />
                          کمی‌صبر‌کنید...
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </div>
              <div className="container">
                <div className="row form-group mb-0 mt-10 p-10 bg-white align-items-center text-md-right rounded">
                  <div className="col-12 col-md-6"> عضویت در سایت </div>
                  <div className="col-12 col-md-6 text-center text-md-left">
                    <Link
                      to={REGISTER_URL_LOCAL}
                      className="signin-signup btn mt-10 mt-md-1"
                      style={{ padding: "0.4625rem 1.1875rem" }}
                    >
                      ثبت‌نام کنید.
                    </Link>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row mt-2 form-group mb-0 mt-10 align-items-center p-10 bg-white text-md-right rounded">
                  <div className="col-12 col-md-6">حساب کاربری دارید؟</div>
                  <div className="col-12 col-md-6 text-center text-md-left">
                    <Link
                      to={LOGIN_URL_LOCAL}
                      className="signin-signupb btn mt-10 mt-md-1"
                      style={{ padding: "0.4625rem 1.1875rem" }}
                    >
                      ورود به حساب
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3"></div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ChangePassword;
